import { Label, Modal } from "flowbite-react";
import React, { useContext } from "react";
import { AuthContext } from "../components/shared/AuthProvider";

const DownloadInfoModal = ({ setDownloadInfoModal, downloadInfoModal }) => {
  const { setBuyer } = useContext(AuthContext);

  const handleDownloadInfo = (e) => {
    e.preventDefault();
    const form = e.target;
    const buyer = form.buyer.value;
    const address = form.mobile.value;
    const discount = parseInt(form.discount.value);
    const previousDue = parseInt(form.previousDue.value);
    setBuyer({ buyerName: buyer, address: address, discount, previousDue });

    setDownloadInfoModal(!downloadInfoModal);
  };
  return (
    <div>
      <React.Fragment>
        <Modal show={downloadInfoModal} size="lg">
          <Modal.Header
            onClick={() => setDownloadInfoModal(!downloadInfoModal)}
          />
          <Modal.Body>
            <div
              onSubmit={handleDownloadInfo}
              className="space-y-6 px-6 pb-4 sm:pb-6 lg:px-8 xl:pb-8"
            >
              <form>
                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="buyer" value="Bill To" />
                  </div>
                  <input
                    id="buyer"
                    placeholder="Hasan Pharmecy"
                    name="buyer"
                    className="w-full block border-2 p-3 rounded"
                    required
                  />
                </div>
                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="mobile" value="Mobile or Address" />
                  </div>
                  <input
                    id="mobile"
                    type="text"
                    name="mobile"
                    className="w-full block border-2 p-3 rounded"
                  />
                </div>
                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="discount" value="Discount (TK)" />
                  </div>
                  <input
                    id="discount"
                    type="number"
                    name="discount"
                    className="w-full block border-2 p-3 rounded"
                    required
                  />
                </div>
                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="prev due" value="Previous Due (TK)" />
                  </div>
                  <input
                    id="previousDue"
                    type="number"
                    name="previousDue"
                    className="w-full block border-2 p-3 rounded"
                    required
                  />
                </div>
                <div>
                  <button
                    className="inline-block bg-gradient-to-r from-cyan-500 to-blue-500 
                    px-4 text-center w-full py-2 my-3 text-white font-medium text-lg rounded-lg"
                  >
                    Add info
                  </button>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    </div>
  );
};

export default DownloadInfoModal;
